<template>
	<div class="org-stock-money-change">
		<!-- GTS季度达成率功能区域 -->
		<div class="quarter-achieving-section">
			<div class="section-title">平台进销存</div>
			<div class="search-area">
				<div class="search-item">
					<span class="label">年份：</span>
					<el-date-picker style="width: 120px;" v-model="searchForm.Year" type="year"
						placeholder="选择年份(不选默认历年年度)" size="small" value-format="yyyy" :editable="false"
						clearable></el-date-picker>
				</div>
				<div class="search-item">
					<span class="label">渠道：</span>
					<el-select v-model="searchForm.AccType" style="width: 120px;" placeholder="请选择渠道" size="small">
						<el-option label="U8" value="U8"></el-option>
						<el-option label="U9" value="U9"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">产品线：</span>
					<el-select v-model="searchForm.InvClass" placeholder="请选择产品线" size="small" filterable clearable
						multiple collapse-tags @change="handleInvClassChange">
						<el-option v-for="option in productLineOptions" :key="option.value" :label="option.label"
							:value="option.value"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">LEVEL2：</span>
					<el-select v-model="searchForm.LEVEL2" placeholder="请选择" size="small" filterable clearable multiple
						collapse-tags @change="handleLevel2Change">
						<el-option v-for="option in level2Options" :key="option.value" :label="option.label"
							:value="option.value"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">LEVEL3：</span>
					<el-select v-model="searchForm.LEVEL3" placeholder="请选择" size="small" filterable clearable multiple
						collapse-tags>
						<el-option v-for="option in level3Options" :key="option.value" :label="option.label"
							:value="option.value"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">平台：</span>
					<el-select v-model="searchForm.CompanyIDs" placeholder="请选择平台" size="small" filterable clearable
						multiple collapse-tags style="width:322px">
						<el-option v-for="option in firstOrgOptions" :key="option.value" :label="option.label"
							:value="option.value"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">年月区间：</span>
					<el-date-picker v-model="searchForm.MonthRange" type="monthrange" range-separator="至"
						start-placeholder="开始月份" end-placeholder="结束月份" size="small"
						value-format="yyyy-MM"></el-date-picker>
				</div>
				<div class="search-item">
					<span class="label">产品名称：</span>
					<el-select style="width: 300px;" v-model="searchForm.InvName" filterable remote
						reserve-keyword placeholder="请输入关键词" size="small" :remote-method="remoteMethod"
						:loading="productNameLoading" multiple collapse-tags :disabled="!searchForm.InvClass || searchForm.InvClass.length === 0"
						clearable>
						<el-option v-for="item in productNameOptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="button-group">
					<el-button size="small" @click="handleReset">重置</el-button>
					<el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
					<el-button size="small" class="refresh-btn" @click="handleRefresh"
						:loading="refreshing">刷新</el-button>
				</div>
			</div>

			<div class="content-area">
				<el-spinner v-if="loading" style="margin: 20px auto; display: block;"></el-spinner>
				<el-empty v-else-if="!reportData || !reportData.length" description="暂无数据"></el-empty>
				<div v-else>
					<div class="chart-container" style="padding: 20px 20px 40px 20px;">
						<div ref="quarterChart" style="width: 100%; height: 600px;"></div>
					</div>
					<div class="chart-lines"></div>
					<!-- 进货业务占比和销售业务占比环形图 -->
					<div class="pie-charts-container"
						style="display: flex; justify-content: center; align-items: center; padding: 0 20px 40px 20px;">
						<div ref="purchasePieChart" style="width: 35%; height: 350px;"></div>
						<!-- 共享图例容器 -->
						<div ref="sharedLegend"
							style="width: 20%; height: 350px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
						</div>
						<div ref="salesPieChart" style="width: 35%; height: 350px;"></div>
					</div>
					<div class="chart-lines"></div>
					<!-- 业务占比下方的列表 -->
					<div class="list-container" style="padding: 30px 20px;">
						<div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
							<el-button size="small" @click="handleExportList" :loading="exportingList">导出</el-button>
						</div>
						<el-table :data="listData" border size="small" style="width: 100%"
							:span-method="objectSpanMethod" v-loading="listLoading" :header-cell-style="headerCellStyle"
							:header-cell-class-name="headerCellClassName"
							:cell-style="{ textAlign: 'center', padding: '4px 0' }">
							<el-table-column prop="AbbName" :label="listTitle" min-width="120"
								fixed="left"></el-table-column>
							<el-table-column prop="InvClassName" label="" min-width="120" fixed="left">
								<template slot-scope="scope">
									<span :style="{ color: getInvClassColor(scope.row.InvClassName) }">{{
										scope.row.InvClassName }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="YTD" label="YTD" min-width="110">
								<template slot-scope="scope">{{ formatNumber(scope.row.YTD) }}</template>
							</el-table-column>
							<el-table-column prop="Q1" label="Q1" min-width="110">
								<template slot-scope="scope">{{ formatNumber(scope.row.Q1) }}</template>
							</el-table-column>
							<el-table-column prop="Q2" label="Q2" min-width="110">
								<template slot-scope="scope">{{ formatNumber(scope.row.Q2) }}</template>
							</el-table-column>
							<el-table-column prop="Q3" label="Q3" min-width="110">
								<template slot-scope="scope">{{ formatNumber(scope.row.Q3) }}</template>
							</el-table-column>
							<el-table-column prop="Q4" label="Q4" min-width="110">
								<template slot-scope="scope">{{ formatNumber(scope.row.Q4) }}</template>
							</el-table-column>
							<el-table-column prop="Jan" label="1月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.Jan) }}</template>
							</el-table-column>
							<el-table-column prop="Feb" label="2月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.Feb) }}</template>
							</el-table-column>
							<el-table-column prop="Mar" label="3月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.Mar) }}</template>
							</el-table-column>
							<el-table-column prop="Apr" label="4月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.Apr) }}</template>
							</el-table-column>
							<el-table-column prop="May" label="5月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.May) }}</template>
							</el-table-column>
							<el-table-column prop="Jun" label="6月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.Jun) }}</template>
							</el-table-column>
							<el-table-column prop="Jul" label="7月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.Jul) }}</template>
							</el-table-column>
							<el-table-column prop="Aug" label="8月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.Aug) }}</template>
							</el-table-column>
							<el-table-column prop="Sep" label="9月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.Sep) }}</template>
							</el-table-column>
							<el-table-column prop="Oct" label="10月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.Oct) }}</template>
							</el-table-column>
							<el-table-column prop="Nov" label="11月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.Nov) }}</template>
							</el-table-column>
							<el-table-column prop="Dec" label="12月" min-width="100">
								<template slot-scope="scope">{{ formatNumber(scope.row.Dec) }}</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>

		<!-- 平台库存资金变动图表 -->
		<div class="stock-money-change-section" style="margin-top: 20px; margin-bottom: 20px;">
			<div class="section-title">平台库存资金变动</div>
			<div class="search-area">
				<div class="search-item">
					<span class="label">年份：</span>
					<el-date-picker v-model="stockMoneyChangeForm.Year" type="year" placeholder="选择年份" size="small"
						value-format="yyyy" :editable="false" clearable></el-date-picker>
				</div>
				<div class="search-item">
					<span class="label">月度区间：</span>
					<el-date-picker v-model="stockMoneyChangeForm.MonthRange" type="monthrange" range-separator="至"
						start-placeholder="开始月份" end-placeholder="结束月份" size="small" value-format="yyyy-MM">
					</el-date-picker>
				</div>
				<div class="search-item">
					<span class="label">维度：</span>
					<el-select v-model="stockMoneyChangeForm.ByQuarter" placeholder="请选择维度" size="small"
						style="width: 150px;">
						<el-option label="月度" :value="0"></el-option>
						<el-option label="季度" :value="1"></el-option>
						<el-option label="年度" :value="2"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">产品线：</span>
					<el-select v-model="stockMoneyChangeForm.InvClass" placeholder="请选择产品线" size="small" filterable
						clearable multiple collapse-tags>
						<el-option v-for="option in productLineOptions" :key="option.value" :label="option.label"
							:value="option.value"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">平台：</span>
					<el-select v-model="stockMoneyChangeForm.CompanyIDs" placeholder="请选择平台" size="small" filterable
						clearable multiple collapse-tags style="width:330px">
						<el-option v-for="option in firstOrgOptions" :key="option.value" :label="option.label"
							:value="option.value"></el-option>
					</el-select>
				</div>
				<div class="button-group">
					<el-button size="small" @click="handleStockMoneyChangeReset">重置</el-button>
					<el-button type="primary" size="small" @click="handleStockMoneyChangeSearch">搜索</el-button>
					<el-button size="small" @click="handleStockMoneyChangeExport">导出</el-button>
				</div>
			</div>

			<div class="content-area">
				<el-spinner v-if="stockMoneyChangeLoading" style="margin: 20px auto; display: block;"></el-spinner>
				<el-empty v-else-if="!stockMoneyChangeData || !stockMoneyChangeData.length"
					description="暂无数据"></el-empty>
				<div v-else>
					<div class="view-switch-list"
						style="display: flex; justify-content: flex-end; padding: 20px 20px 0 0;">
						<div class="view-switch">
							<div class="switch-item-red" v-for="(item, index) in stockMoneyChangeChartTypeOptions"
								:key="index" :class="[stockMoneyChangeChartTypeIndex === index ? 'current-red' : '']"
								@click="handleChartTypeChange(index)">
								{{ item }}
							</div>
						</div>
					</div>
					<div class="chart-container" style="padding: 20px 20px 40px 20px;">
						<div ref="stockMoneyChangeChart" style="width: 100%; height: 400px;"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	RefreshNTSQuarterAchievingRate,
	GetNTSQuarterAchievingRate,
	GetNTSQuarterAchievingRateList,
	ExportNTSQuarterAchievingRateList,
	GetOrgStockMoneyChange,
	OrgStockMoneyChangeExport,
	GetFirstOrganization,
	GetLevel2List,
	GetLevel3List,
	GetInvNameList
} from '@/api/newsapi';
import {
	InventoryClassList
} from '@/api/home';

export default {
	name: 'OrgStockMoneyChange',
	data() {
		return {
			// GTS季度达成率表单数据
			searchForm: {
				Year: new Date().getFullYear().toString(),
				AccType: 'U9',
				InvClass: [],
				LEVEL2: [],
				LEVEL3: [],
				MonthRange: [],
				CompanyIDs: [],
				InvName: []
			},
			reportData: [],
			loading: false,
			refreshing: false,
			level2Options: [],
			level3Options: [],
			productNameOptions: [], // 产品名称搜索结果
			productNameLoading: false, // 产品名称搜索加载状态

			// 业务占比列表数据
			listData: [],
			listLoading: false,
			exportingList: false,
			listTitle: '产品线',
			spanArr: [],

			// 平台库存资金变动表单数据
			stockMoneyChangeForm: {
				Year: '',
				MonthRange: [],
				InvClass: [],
				CompanyIDs: [],
				ByQuarter: 0
			},
			stockMoneyChangeData: [],
			stockMoneyChangeLoading: false,
			stockMoneyChangeChartTypeOptions: ['折线图', '柱状图'],
			stockMoneyChangeChartTypeIndex: 1,
			productLineOptions: [],
			firstOrgOptions: []
		};
	},
	mounted() {
		this.stockMoneyChangeForm.Year = new Date().getFullYear().toString();
		this.handleSearch();
		this.initProductLineOptions();
		this.initFirstOrgOptions();
		this.handleStockMoneyChangeSearch();
	},
	methods: {
		// 绘制GTS达成图表
		drawQuarterChart() {
			const dom = this.$refs.quarterChart;
			if (!dom || !this.reportData || this.reportData.length === 0) return;

			let myChart = this.$MyEcharts.getInstanceByDom(dom);
			if (myChart) {
				myChart.dispose();
			}
			myChart = this.$MyEcharts.init(dom);

			// reportData is an array of objects
			// e.g., [{"CompanyID":"1661","CompanyName":"国科恒铠（上海）医疗科技有限公司","PurchaseGTS":{"TotalSum":18267109,"YearBasis":103.2,"Proportion":5.5},"SalesOutGTS":{"TotalSum":13602008.58,"YearBasis":181.5,"Proportion":4.3},"Stock":{"TotalSum":20493812.11}}]

			// 因为ECharts的 yAxis type 'category' 默认从下往上画图，为了让第一名（进货GTS最大）在最上面，需要将数组反转
			const chartData = [...this.reportData].reverse();

			const yAxisData = chartData.map(item => item.CompanyName);

			// Extract series data
			const purchaseData = chartData.map(item => item.PurchaseGTS ? item.PurchaseGTS.TotalSum : 0);
			const salesOutData = chartData.map(item => item.SalesOutGTS ? item.SalesOutGTS.TotalSum : 0);
			const stockData = chartData.map(item => item.Stock ? item.Stock.TotalSum : 0);

			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					formatter: (params) => {
						let result = params[0].name + '<br/>';
						params.forEach(param => {
							const dataIndex = param.dataIndex;
							const rowData = chartData[dataIndex];
							let val = param.value.toLocaleString();

							result += `${param.marker}${param.seriesName}: <b>${val}</b>`;

							if (param.seriesName === '进货GTS') {
								if (rowData.PurchaseGTS) {
									let yb = rowData.PurchaseGTS.YearBasis || 0;
									let arrow = '';
									let color = 'inherit';
									if (yb > 0) {
										arrow = '↑';
										color = '#52c41a'; // 绿色
									} else if (yb < 0) {
										arrow = '↓';
										color = '#ff4d4f'; // 红色
									}
									result +=
										` (同比: <span style="color: ${color}">${yb}% ${arrow}</span>, 占比: ${rowData.PurchaseGTS.Proportion || 0}%)`;
								}
							} else if (param.seriesName === '销售GTS') {
								if (rowData.SalesOutGTS) {
									let yb = rowData.SalesOutGTS.YearBasis || 0;
									let arrow = '';
									let color = 'inherit';
									if (yb > 0) {
										arrow = '↑';
										color = '#52c41a'; // 绿色
									} else if (yb < 0) {
										arrow = '↓';
										color = '#ff4d4f'; // 红色
									}
									result +=
										` (同比: <span style="color: ${color}">${yb}% ${arrow}</span>, 占比: ${rowData.SalesOutGTS.Proportion || 0}%)`;
								}
							}
							result += '<br/>';
						});
						return result;
					}
				},
				legend: {
					data: ['进货GTS', '销售GTS', '库存']
				},
				grid: {
					left: '3%',
					right: '5%', // 恢复较小的右侧边距，利用 xAxis.max 留出文本空间
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					type: 'value',
					max: function (value) {
						// 将 X 轴最大值设为数据最大值的 1.33 倍（即 1 / 0.75）
						// 这样数据最大值（最长的柱子）只会占据图表宽度的 75%
						return value.max / 0.75;
					},
					axisLabel: {
						formatter: (value) => {
							return (value / 10000).toLocaleString() + '万';
						}
					}
				},
				yAxis: {
					type: 'category',
					data: yAxisData,
					axisLabel: {
						interval: 0,
						formatter: function (params) {
							let newParamsName = "";
							let paramsNameNumber = params.length;
							let provideNumber = 10; // 每行最多显示10个字
							let rowNumber = Math.ceil(paramsNameNumber / provideNumber);

							if (paramsNameNumber > provideNumber) {
								for (let p = 0; p < rowNumber; p++) {
									let tempStr = "";
									let start = p * provideNumber;
									let end = start + provideNumber;
									if (p == rowNumber - 1) {
										tempStr = params.substring(start, paramsNameNumber);
									} else {
										tempStr = params.substring(start, end) + "\n";
									}
									newParamsName += tempStr;
								}
							} else {
								newParamsName = params;
							}
							return newParamsName;
						}
					}
				},
				series: [{
					name: '进货GTS',
					type: 'bar',
					data: purchaseData,
					itemStyle: {
						color: '#e71d43'
					},
					label: {
						show: true,
						position: 'right',
						formatter: (params) => {
							const rowData = chartData[params.dataIndex];
							if (!rowData || !rowData.PurchaseGTS) return params.value.toLocaleString();
							const p = rowData.PurchaseGTS;
							let yb = p.YearBasis || 0;
							let arrow = '';
							let style = 'normal';
							if (yb > 0) {
								arrow = '↑';
								style = 'up';
							} else if (yb < 0) {
								arrow = '↓';
								style = 'down';
							}
							return `${params.value.toLocaleString()} / 同比: {${style}|${yb}% ${arrow}} / 占比: ${p.Proportion || 0}%`;
						},
						rich: {
							up: {
								color: '#52c41a'
							},
							down: {
								color: '#ff4d4f'
							},
							normal: {
								color: '#666'
							}
						},
						color: '#666',
						fontSize: 11
					}
				},
				{
					name: '销售GTS',
					type: 'bar',
					data: salesOutData,
					itemStyle: {
						color: '#00266D'
					},
					label: {
						show: true,
						position: 'right',
						formatter: (params) => {
							const rowData = chartData[params.dataIndex];
							if (!rowData || !rowData.SalesOutGTS) return params.value.toLocaleString();
							const p = rowData.SalesOutGTS;
							let yb = p.YearBasis || 0;
							let arrow = '';
							let style = 'normal';
							if (yb > 0) {
								arrow = '↑';
								style = 'up';
							} else if (yb < 0) {
								arrow = '↓';
								style = 'down';
							}
							return `${params.value.toLocaleString()} / 同比: {${style}|${yb}% ${arrow}} / 占比: ${p.Proportion || 0}%`;
						},
						rich: {
							up: {
								color: '#52c41a'
							},
							down: {
								color: '#ff4d4f'
							},
							normal: {
								color: '#666'
							}
						},
						color: '#666',
						fontSize: 11
					}
				},
				{
					name: '库存',
					type: 'bar',
					data: stockData,
					itemStyle: {
						color: '#A5A5A5'
					},
					label: {
						show: true,
						position: 'right',
						formatter: (params) => {
							return params.value.toLocaleString();
						},
						color: '#666',
						fontSize: 11
					}
				}
				]
			};

			myChart.setOption(option);
			window.addEventListener("resize", () => {
				myChart.resize();
			});
		},
		// 绘制进货和销售业务占比环形图
		drawPieCharts() {
			const purchaseDom = this.$refs.purchasePieChart;
			const salesDom = this.$refs.salesPieChart;
			const legendDom = this.$refs.sharedLegend;

			if (!purchaseDom || !salesDom || !legendDom || !this.reportData || this.reportData.length === 0) return;

			let purchaseChart = this.$MyEcharts.getInstanceByDom(purchaseDom);
			if (purchaseChart) {
				purchaseChart.dispose();
			}
			purchaseChart = this.$MyEcharts.init(purchaseDom);

			let salesChart = this.$MyEcharts.getInstanceByDom(salesDom);
			if (salesChart) {
				salesChart.dispose();
			}
			salesChart = this.$MyEcharts.init(salesDom);

			// 定义平台颜色映射
			const platformColorMap = {
				'致新': '#E71D43',    // 红
				'美勒丰': '#00266D',  // 蓝
				'国科': '#00838F',    // 蓝绿
				'国药': '#8C8C8C',    // 灰
				'上海赋蕴': '#8C8C8C' // 灰 (补充血透线)
			};

			// 根据名称获取颜色
			const getColorByName = (name) => {
				for (const key in platformColorMap) {
					if (name.includes(key)) {
						return platformColorMap[key];
					}
				}
				return '#5470c6'; // 默认色
			};

			// 提取进货GTS数据
			const purchaseData = this.reportData.map(item => {
				return {
					name: item.CompanyName,
					value: item.PurchaseGTS ? item.PurchaseGTS.TotalSum : 0,
					itemStyle: { color: getColorByName(item.CompanyName) }
				};
			}).filter(item => item.value > 0);

			// 提取销售GTS数据
			const salesData = this.reportData.map(item => {
				return {
					name: item.CompanyName,
					value: item.SalesOutGTS ? item.SalesOutGTS.TotalSum : 0,
					itemStyle: { color: getColorByName(item.CompanyName) }
				};
			}).filter(item => item.value > 0);

			// 收集所有出现的平台名称用于图例
			const legendDataNames = new Set([...purchaseData.map(d => d.name), ...salesData.map(d => d.name)]);
			const legendDataList = Array.from(legendDataNames).map(name => {
				return {
					name: name,
					icon: 'circle',
					itemStyle: { color: getColorByName(name) }
				};
			});

			const getPieOption = (title, data) => {
				return {
					title: {
						text: title,
						left: '50%',
						textAlign: 'center',
						top: 20,
						textStyle: {
							color: '#333',
							fontSize: 16,
							fontWeight: 'bold'
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: function (params) {
							return `${params.seriesName} <br/>${params.name} : ${params.value.toLocaleString()} (${params.percent}%)`;
						}
					},
					legend: {
						show: false // 隐藏内部图例，使用外部共享图例
					},
					series: [{
						name: title,
						type: 'pie',
						radius: ['45%', '70%'],
						center: ['50%', '55%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 5,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 14,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: data
					}]
				};
			};

			purchaseChart.setOption(getPieOption('进货业务占比', purchaseData));
			salesChart.setOption(getPieOption('销售业务占比', salesData));

			// 手动渲染中间的共享图例
			legendDom.innerHTML = '';
			const legendWrapper = document.createElement('div');
			legendWrapper.style.display = 'flex';
			legendWrapper.style.flexDirection = 'column';
			legendWrapper.style.alignItems = 'flex-start'; // 图例文字左对齐

			legendDataList.forEach(item => {
				const legendItem = document.createElement('div');
				legendItem.style.display = 'flex';
				legendItem.style.alignItems = 'center';
				legendItem.style.marginBottom = '12px';
				legendItem.style.cursor = 'pointer';
				legendItem.style.fontSize = '12px';
				legendItem.style.color = '#333';

				const colorBlock = document.createElement('span');
				colorBlock.style.display = 'inline-block';
				colorBlock.style.width = '12px';
				colorBlock.style.height = '12px';
				colorBlock.style.borderRadius = '50%';
				colorBlock.style.backgroundColor = item.itemStyle.color;
				colorBlock.style.marginRight = '8px';

				const textSpan = document.createElement('span');
				textSpan.innerText = item.name;

				legendItem.appendChild(colorBlock);
				legendItem.appendChild(textSpan);

				// 添加图例交互：鼠标悬浮高亮对应扇区并显示 tooltip
				legendItem.addEventListener('mouseenter', () => {
					purchaseChart.dispatchAction({ type: 'highlight', name: item.name });
					salesChart.dispatchAction({ type: 'highlight', name: item.name });

					// 显示 Tooltip
					purchaseChart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						name: item.name
					});
					salesChart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						name: item.name
					});
				});
				legendItem.addEventListener('mouseleave', () => {
					purchaseChart.dispatchAction({ type: 'downplay', name: item.name });
					salesChart.dispatchAction({ type: 'downplay', name: item.name });

					// 隐藏 Tooltip
					purchaseChart.dispatchAction({
						type: 'hideTip'
					});
					salesChart.dispatchAction({
						type: 'hideTip'
					});
				});

				legendWrapper.appendChild(legendItem);
			});
			legendDom.appendChild(legendWrapper);

			window.addEventListener("resize", () => {
				purchaseChart.resize();
				salesChart.resize();
			});
		},
		// GTS季度达成率重置按钮点击事件
		handleReset() {
			this.searchForm = {
				Year: new Date().getFullYear().toString(),
				AccType: 'U9',
				InvClass: [],
				LEVEL2: [],
				LEVEL3: [],
				MonthRange: [],
				CompanyIDs: [],
				InvName: []
			};
			this.level2Options = [];
			this.level3Options = [];
			this.productNameOptions = [];
			this.handleSearch();
		},
		// GTS季度达成率搜索按钮点击事件
		handleSearch() {
			this.loading = true;
			let StartMonth = '';
			let EndMonth = '';
			if (this.searchForm.MonthRange && this.searchForm.MonthRange.length === 2) {
				StartMonth = this.searchForm.MonthRange[0];
				EndMonth = this.searchForm.MonthRange[1];
			}

			let params = {
				...this.searchForm,
				StartMonth: StartMonth,
				EndMonth: EndMonth,
				InvClass: Array.isArray(this.searchForm.InvClass) ? this.searchForm.InvClass.join(',') : this
					.searchForm.InvClass,
				LEVEL2: Array.isArray(this.searchForm.LEVEL2) ? this.searchForm.LEVEL2.join(',') : this.searchForm
					.LEVEL2,
				LEVEL3: Array.isArray(this.searchForm.LEVEL3) ? this.searchForm.LEVEL3.join(',') : this.searchForm
					.LEVEL3,
				CompanyIDs: Array.isArray(this.searchForm.CompanyIDs) ? this.searchForm.CompanyIDs.join(',') : this
					.searchForm.CompanyIDs,
				InvName: Array.isArray(this.searchForm.InvName) ? this.searchForm.InvName.join(',') : this
					.searchForm.InvName
			};
			if (!params.Year || params.Year === '') {
				delete params.Year;
			}
			delete params.MonthRange;

			GetNTSQuarterAchievingRate(params)
				.then(res => {
					if (res.code === 0) {
						this.reportData = res.data;
					} else {
						this.reportData = [];
						this.$message.error(res.message || '获取数据失败');
					}
				})
				.catch(err => {
					this.reportData = [];
					// 捕获到错误时，尝试从err.response.data中获取message
					const errorMessage = err.response?.data?.message || '获取数据失败';
					this.$message.error(errorMessage);
				})
				.finally(() => {
					this.loading = false;
					// 必须在 loading 变为 false 且 nextTick 后，图表容器 DOM 才会真正渲染
					this.$nextTick(() => {
						this.drawQuarterChart();
						this.drawPieCharts();
					});
				});

			this.loadListData();
		},
		// GTS季度达成率刷新按钮点击事件
		handleRefresh() {
			this.refreshing = true;
			let StartMonth = '';
			let EndMonth = '';
			if (this.searchForm.MonthRange && this.searchForm.MonthRange.length === 2) {
				StartMonth = this.searchForm.MonthRange[0];
				EndMonth = this.searchForm.MonthRange[1];
			}

			let params = {
				...this.searchForm,
				StartMonth: StartMonth,
				EndMonth: EndMonth,
				InvClass: Array.isArray(this.searchForm.InvClass) ? this.searchForm.InvClass.join(',') : this
					.searchForm.InvClass,
				LEVEL2: Array.isArray(this.searchForm.LEVEL2) ? this.searchForm.LEVEL2.join(',') : this.searchForm
					.LEVEL2,
				LEVEL3: Array.isArray(this.searchForm.LEVEL3) ? this.searchForm.LEVEL3.join(',') : this.searchForm
					.LEVEL3,
				CompanyIDs: Array.isArray(this.searchForm.CompanyIDs) ? this.searchForm.CompanyIDs.join(',') : this
					.searchForm.CompanyIDs,
				InvName: Array.isArray(this.searchForm.InvName) ? this.searchForm.InvName.join(',') : this
					.searchForm.InvName
			};
			if (!params.Year || params.Year === '') {
				delete params.Year;
			}
			delete params.MonthRange;

			RefreshNTSQuarterAchievingRate(params)
				.then(res => {
					if (res.code === 0) {
						this.$message.success('刷新成功');
						// 刷新成功后重新获取数据
						this.handleSearch();
					} else {
						this.$message.error(res.message || '刷新失败');
					}
				})
				.catch(err => {
					// 捕获到错误时，尝试从err.response.data中获取message
					const errorMessage = err.response?.data?.message || '刷新失败';
					this.$message.error(errorMessage);
				})
				.finally(() => {
					this.refreshing = false;
				});
		},
		handleInvClassChange(val) {
			this.searchForm.LEVEL2 = [];
			this.searchForm.LEVEL3 = [];
			this.searchForm.InvName = [];
			this.level2Options = [];
			this.level3Options = [];
			this.productNameOptions = [];
			if (val && val.length > 0) {
				GetLevel2List({
					InvClass: val.join(',')
				}).then(res => {
					if (res.code === 0) {
						this.level2Options = res.data.map(item => ({
							value: item.Value,
							label: item.Text
						}));
					}
				});
			}
		},
		// 产品名称远程搜索方法
		remoteMethod(queryString) {
			if (!this.searchForm.InvClass || this.searchForm.InvClass.length === 0) {
				this.productNameOptions = [];
				return;
			}

			this.productNameLoading = true;
			GetInvNameList({
				InvClass: this.searchForm.InvClass.join(','),
				InvName: queryString
			})
				.then(res => {
					if (res.code === 0) {
						this.productNameOptions = res.data.map(item => ({
							value: item.InvName,
							label: item.InvName
						}));
					} else {
						this.productNameOptions = [];
					}
				})
				.catch(() => {
					this.productNameOptions = [];
				})
				.finally(() => {
					this.productNameLoading = false;
				});
		},
		handleLevel2Change(val) {
			this.searchForm.LEVEL3 = [];
			this.level3Options = [];
			if (val && val.length > 0) {
				GetLevel3List({
					InvClass: this.searchForm.InvClass.join(','),
					LEVEL2: val.join(',')
				}).then(res => {
					if (res.code === 0) {
						this.level3Options = res.data.map(item => ({
							value: item.Value,
							label: item.Text
						}));
					}
				});
			}
		},
		// 初始化产品线选项
		initProductLineOptions() {
			InventoryClassList().then(res => {
				if (res.code === 0) {
					this.productLineOptions = res.data.data.map(item => ({
						value: item.InvClass,
						label: item.InvClassName
					}));
				}
			}).catch(err => {
				console.error('获取产品线列表失败:', err);
			});
		},
		// 初始化一级组织选项
		initFirstOrgOptions() {
			GetFirstOrganization().then(res => {
				if (res.code === 0) {
					this.firstOrgOptions = res.data.map(item => ({
						value: item.Value,
						label: item.Text
					}));
				}
			}).catch(err => {
				console.error('获取一级组织列表失败:', err);
			});
		},

		// 列表相关方法
		loadListData() {
			this.listLoading = true;
			let StartMonth = '';
			let EndMonth = '';
			if (this.searchForm.MonthRange && this.searchForm.MonthRange.length === 2) {
				StartMonth = this.searchForm.MonthRange[0];
				EndMonth = this.searchForm.MonthRange[1];
			}

			let params = {
				...this.searchForm,
				StartMonth: StartMonth,
				EndMonth: EndMonth,
				InvClass: Array.isArray(this.searchForm.InvClass) ? this.searchForm.InvClass.join(',') : this.searchForm.InvClass,
				LEVEL2: Array.isArray(this.searchForm.LEVEL2) ? this.searchForm.LEVEL2.join(',') : this.searchForm.LEVEL2,
				LEVEL3: Array.isArray(this.searchForm.LEVEL3) ? this.searchForm.LEVEL3.join(',') : this.searchForm.LEVEL3,
				CompanyIDs: Array.isArray(this.searchForm.CompanyIDs) ? this.searchForm.CompanyIDs.join(',') : this.searchForm.CompanyIDs,
				InvName: Array.isArray(this.searchForm.InvName) ? this.searchForm.InvName.join(',') : this.searchForm.InvName
			};
			if (!params.Year || params.Year === '') {
				delete params.Year;
			}
			delete params.MonthRange;

			GetNTSQuarterAchievingRateList(params).then(res => {
				if (res.code === 0) {
					this.listData = res.data.result || res.data || [];
					this.listTitle = res.data.InvClassName || '产品线';
					this.computeSpanMethod();
				} else {
					this.listData = [];
					this.$message.error(res.message || '获取列表数据失败');
				}
			}).catch(err => {
				this.listData = [];
				const errorMessage = err.response?.data?.message || '获取列表数据失败';
				this.$message.error(errorMessage);
			}).finally(() => {
				this.listLoading = false;
			});
		},
		computeSpanMethod() {
			this.spanArr = [];
			let pos = 0;
			for (let i = 0; i < this.listData.length; i++) {
				if (i === 0) {
					this.spanArr.push(1);
					pos = 0;
				} else {
					if (this.listData[i].AbbName === this.listData[i - 1].AbbName) {
						this.spanArr[pos] += 1;
						this.spanArr.push(0);
					} else {
						this.spanArr.push(1);
						pos = i;
					}
				}
			}
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				const _row = this.spanArr[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			}
		},
		formatNumber(val) {
			if (val === null || val === undefined) return '';
			return Number(val).toLocaleString('zh-CN', { maximumFractionDigits: 0 });
		},
		getInvClassColor(name) {
			if (name && (name.includes('库存') || name.includes('天数'))) {
				return '#ff4d4f';
			}
			return 'inherit';
		},
		headerCellStyle({ row, column, rowIndex, columnIndex }) {
			let style = { textAlign: 'center', padding: '4px 0', color: '#fff' };
			// 判断是否是 Q1-Q4 的列
			if (['Q1', 'Q2', 'Q3', 'Q4'].includes(column.label)) {
				style.background = '#e71d43'; // 红色
			} else {
				style.background = '#00266D'; // 蓝色
			}
			return style;
		},
		// 合并产品线表头
		headerCellClassName({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) return 'merge-header-left';
			if (columnIndex === 1) return 'merge-header-right';
			return '';
		},
		handleExportList() {
			this.exportingList = true;
			let StartMonth = '';
			let EndMonth = '';
			if (this.searchForm.MonthRange && this.searchForm.MonthRange.length === 2) {
				StartMonth = this.searchForm.MonthRange[0];
				EndMonth = this.searchForm.MonthRange[1];
			}

			let params = {
				...this.searchForm,
				StartMonth: StartMonth,
				EndMonth: EndMonth,
				InvClass: Array.isArray(this.searchForm.InvClass) ? this.searchForm.InvClass.join(',') : this.searchForm.InvClass,
				LEVEL2: Array.isArray(this.searchForm.LEVEL2) ? this.searchForm.LEVEL2.join(',') : this.searchForm.LEVEL2,
				LEVEL3: Array.isArray(this.searchForm.LEVEL3) ? this.searchForm.LEVEL3.join(',') : this.searchForm.LEVEL3,
				CompanyIDs: Array.isArray(this.searchForm.CompanyIDs) ? this.searchForm.CompanyIDs.join(',') : this.searchForm.CompanyIDs,
				InvName: Array.isArray(this.searchForm.InvName) ? this.searchForm.InvName.join(',') : this.searchForm.InvName
			};
			if (!params.Year || params.Year === '') {
				delete params.Year;
			}
			delete params.MonthRange;

			ExportNTSQuarterAchievingRateList(params).then(res => {
				const blob = new Blob([res]);
				const fileName = '业务占比列表.xlsx';
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = fileName;
				link.click();
				window.URL.revokeObjectURL(link.href);
			}).catch(err => {
				this.$message.error('导出失败');
			}).finally(() => {
				this.exportingList = false;
			});
		},

		// 平台库存资金变动重置
		handleStockMoneyChangeReset() {
			this.stockMoneyChangeForm = {
				Year: new Date().getFullYear().toString(),
				MonthRange: [],
				InvClass: [],
				CompanyIDs: [],
				ByQuarter: 0
			};
			this.handleStockMoneyChangeSearch();
		},
		// 平台库存资金变动搜索
		handleStockMoneyChangeSearch() {
			this.stockMoneyChangeLoading = true;
			let StartDate = '';
			let EndDate = '';
			if (this.stockMoneyChangeForm.MonthRange && this.stockMoneyChangeForm.MonthRange.length === 2) {
				StartDate = this.stockMoneyChangeForm.MonthRange[0];
				EndDate = this.stockMoneyChangeForm.MonthRange[1];
				// 更新年份，取开始日期的年份
				// this.stockMoneyChangeForm.Year = this.stockMoneyChangeForm.MonthRange[0].split('-')[0];
			}

			let params = {
				...this.stockMoneyChangeForm,
				StartDate: StartDate,
				EndDate: EndDate,
				InvClass: Array.isArray(this.stockMoneyChangeForm.InvClass) ? this.stockMoneyChangeForm.InvClass
					.join(',') : this.stockMoneyChangeForm.InvClass,
				CompanyIDs: Array.isArray(this.stockMoneyChangeForm.CompanyIDs) ? this.stockMoneyChangeForm
					.CompanyIDs : this.stockMoneyChangeForm.CompanyIDs
			};
			// 只有在 Year 有值且不为空字符串时才保留
			if (!params.Year || params.Year === '') {
				delete params.Year;
			}
			delete params.MonthRange; // 移除 MonthRange
			delete params.StartMonth; // 移除旧参数
			delete params.EndMonth; // 移除旧参数

			GetOrgStockMoneyChange(params)
				.then(res => {
					if (res.code === 0) {
						this.stockMoneyChangeData = res.data;
					} else {
						this.stockMoneyChangeData = [];
						this.$message.error(res.message || '获取数据失败');
					}
				})
				.catch(err => {
					this.stockMoneyChangeData = [];
					const errorMessage = err.response?.data?.message || '获取数据失败';
					this.$message.error(errorMessage);
				})
				.finally(() => {
					this.stockMoneyChangeLoading = false;
					this.$nextTick(() => {
						this.drawStockMoneyChangeChart();
					});
				});
		},
		handleChartTypeChange(index) {
			this.stockMoneyChangeChartTypeIndex = index;
			this.$nextTick(() => {
				this.drawStockMoneyChangeChart();
			});
		},
		// 平台库存资金变动导出
		handleStockMoneyChangeExport() {
			let StartDate = '';
			let EndDate = '';
			if (this.stockMoneyChangeForm.MonthRange && this.stockMoneyChangeForm.MonthRange.length === 2) {
				StartDate = this.stockMoneyChangeForm.MonthRange[0];
				EndDate = this.stockMoneyChangeForm.MonthRange[1];
				// this.stockMoneyChangeForm.Year = this.stockMoneyChangeForm.MonthRange[0].split('-')[0];
			}

			let params = {
				...this.stockMoneyChangeForm,
				StartDate: StartDate,
				EndDate: EndDate,
				InvClass: Array.isArray(this.stockMoneyChangeForm.InvClass) ? this.stockMoneyChangeForm.InvClass
					.join(',') : this.stockMoneyChangeForm.InvClass,
				CompanyIDs: Array.isArray(this.stockMoneyChangeForm.CompanyIDs) ? this.stockMoneyChangeForm
					.CompanyIDs : this.stockMoneyChangeForm.CompanyIDs
			};
			if (!params.Year || params.Year === '') {
				delete params.Year;
			}
			delete params.MonthRange;
			delete params.StartMonth;
			delete params.EndMonth;

			OrgStockMoneyChangeExport(params).then(res => {
				const blob = new Blob([res]);
				const fileName = '平台库存资金变动.xlsx';
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = fileName;
				link.click();
				window.URL.revokeObjectURL(link.href);
			}).catch(err => {
				this.$message.error('导出失败');
			});
		},
		// 绘制平台库存资金变动图表
		drawStockMoneyChangeChart() {
			const dom = this.$refs.stockMoneyChangeChart;
			if (!dom || !this.stockMoneyChangeData || this.stockMoneyChangeData.length === 0) return;

			let myChart = this.$MyEcharts.getInstanceByDom(dom);
			if (myChart) {
				myChart.dispose();
			}
			myChart = this.$MyEcharts.init(dom);

			// 处理新接口数据结构
			// 1. 获取所有日期（X轴）
			const xAxisData = this.stockMoneyChangeData.map(item => item.ReportDate);

			// 2. 获取所有系列名称（ItemName）
			const seriesNames = new Set();
			let hasBackendSummary = false;
			this.stockMoneyChangeData.forEach(dateItem => {
				if (dateItem.Items && Array.isArray(dateItem.Items)) {
					dateItem.Items.forEach(detail => {
						if (detail.ItemName === '汇总') {
							hasBackendSummary = true;
						} else if (detail.ItemName) {
							seriesNames.add(detail.ItemName);
						}
					});
				}
			});
			const legendData = Array.from(seriesNames);

			// 生成颜色和分类
			const platformColors = {
				'美勒丰': ['#E71D43', '#F0627F', '#F593A7', '#F9C2CE', '#FDE0E7'], // 红色渐变
				'致新': ['#00266D', '#33518A', '#667DA8', '#99A8C5', '#CCD4E2'], // 蓝色渐变
				'国科': ['#00838F', '#00ACC1', '#26C6DA', '#4DD0E1', '#80DEEA'], // 蓝绿色渐变
				'国药': ['#8C8C8C', '#BFBFBF', '#D9D9D9', '#F0F0F0', '#F5F5F5'], // 灰色渐变
				'赋蕴': ['#8C8C8C', '#BFBFBF', '#D9D9D9', '#F0F0F0', '#F5F5F5'], // 灰色渐变
				'其他': ['#F57C00', '#26A69A', '#9CCC65', '#D4E157', '#FFA726']
			};
			const getPlatform = (name) => {
				if (name.includes('美勒丰')) return '美勒丰';
				if (name.includes('致新')) return '致新';
				if (name.includes('国科')) return '国科';
				if (name.includes('国药')) return '国药';
				if (name.includes('赋蕴')) return '赋蕴';
				return '其他';
			};
			const nameColors = {};
			const platformCounts = {
				'美勒丰': 0,
				'致新': 0,
				'国科': 0,
				'国药': 0,
				'赋蕴': 0,
				'其他': 0
			};
			const sortedLegend = [...legendData].sort();
			sortedLegend.forEach(name => {
				const p = getPlatform(name);
				const count = platformCounts[p];
				const colors = platformColors[p] || platformColors['其他'];
				nameColors[name] = colors[count % colors.length];
				platformCounts[p]++;
			});

			const isBarChart = this.stockMoneyChangeChartTypeIndex === 1;
			let displayLegendData = [...legendData];

			// 3. 构建系列数据
			const series = legendData.map(name => {
				const data = this.stockMoneyChangeData.map(dateItem => {
					const found = dateItem.Items ? dateItem.Items.find(i => i.ItemName === name) :
						null;
					return found ? found.Money : 0;
				});

				if (isBarChart) {
					return {
						name: name,
						type: 'bar',
						stack: getPlatform(name), // 分组堆叠关键：同一平台的 stack 值相同
						data: data,
						itemStyle: {
							color: nameColors[name]
						},
						barMaxWidth: 60
					};
				} else {
					return {
						name: name,
						type: 'line',
						data: data,
						smooth: true,
						itemStyle: {
							color: nameColors[name] // 保持折线图颜色与柱状图一致
						}
					};
				}
			});

			const summaryData = this.stockMoneyChangeData.map(dateItem => {
				if (hasBackendSummary) {
					const summaryItem = dateItem.Items ? dateItem.Items.find(i => i.ItemName === '汇总') : null;
					return summaryItem ? summaryItem.Money : 0;
				} else {
					let sum = 0;
					if (dateItem.Items) {
						dateItem.Items.forEach(i => {
							if (i.ItemName !== '汇总') sum += i.Money;
						});
					}
					return sum;
				}
			});

			series.push({
				name: '汇总',
				type: 'line',
				data: summaryData,
				smooth: true,
				itemStyle: {
					color: '#FF9800'
				},
				symbolSize: 6,
				zlevel: 10
			});
			displayLegendData.push('汇总');

			const option = {
				tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255, 255, 255, 0.9)',
					borderColor: '#ccc',
					borderWidth: 1,
					textStyle: {
						color: '#333'
					},
					formatter: function (params) {
						let res = params[0].name + '<br/>';
						params.forEach(item => {
							const value = Number(item.value);
							const color = value >= 0 ? '#000000' : '#FF0000';
							res += item.marker + item.seriesName + ': <span style="color:' + color +
								'; font-weight: bold;">' + value.toLocaleString() + '</span><br/>';
						});
						return res;
					}
				},
				legend: {
					data: displayLegendData,
					bottom: 10,
					type: 'scroll'
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '15%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					boundaryGap: isBarChart, // 柱状图时留白
					data: xAxisData
				},
				yAxis: {
					type: 'value',
					name: '金额:万元',
					nameTextStyle: {
						padding: [0, 50, 0, 0]
					},
					axisLabel: {
						formatter: function (value) {
							// 保持原有逻辑，或者根据新需求调整，这里暂时不除以10000，因为新接口返回的是具体金额
							// 如果数值较大，可以考虑 / 10000 并改为 万元
							// 用户示例 Money: -5973203 (-597万)
							// 原代码是 / 10000，这里保持一致性可能更好，但要注意单位
							return (value / 10000).toLocaleString();
						}
					}
				},
				series: series
			};

			myChart.setOption(option, true);
			window.addEventListener("resize", () => {
				myChart.resize();
			});
		}
	}
};
</script>

<style lang="less" scoped>
.org-stock-money-change {
	/* padding: 20px; */
}

.quarter-achieving-section {
	/* margin-top: 20px; */
	/* margin-bottom: 200px; */
}

.section-title {
	font-size: 16px;
	font-weight: bold;
	color: #303133;
	margin-bottom: 15px;
	padding-left: 5px;
}

.search-area {
	background-color: #fff;
	padding: 20px;
	border-radius: 4px;
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 15px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.search-item {
	margin-right: 15px;
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.label {
	margin-right: 10px;
	font-size: 14px;
	color: #606266;
}

.button-group {
	margin-left: auto;
	/* margin-top: 10px; */
}

.button-group .el-button {
	margin-left: 10px;
}

.refresh-btn {
	background-color: #00266D !important;
	color: #fff !important;
	border-color: #00266D !important;
}

.refresh-btn:hover,
.refresh-btn:focus {
	background-color: #00338d !important;
	border-color: #00338d !important;
	color: #fff !important;
}

.refresh-btn.is-loading {
	opacity: 0.8;
}

.content-area {
	min-height: 400px;
	background: #FFFFFF;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.chart-container {
	margin: 0;
}

.chart-lines {
	// border-bottom: 1px solid #cccccc;
	height: 24px;
	background: #F2F3F5;
}

/* 解决带有固定列的表格 loading 被遮挡的问题 */
::v-deep .el-table .el-loading-mask {
	z-index: 2000 !important;
}

::v-deep .el-table__fixed-right::before,
::v-deep .el-table__fixed::before {
	z-index: 9 !important;
}

::v-deep .el-select__input.is-small {
	border: none !important;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner,
::v-deep .el-select .el-input__inner,
::v-deep .el-date-editor.el-input__inner {
	transition: all 0.8s;
	border-radius: 0px;
}

::v-deep .el-input__inner:focus,
::v-deep .el-textarea__inner:focus,
::v-deep .el-select.is-focus .el-input__inner,
::v-deep .el-date-editor.is-focus .el-input__inner {
	border: 1px solid #e71d43 !important;
}

::v-deep .el-loading-spinner {
	margin-top: 0 !important;
}

/* 合并产品线表头 */
::v-deep .el-table th.merge-header-left .cell {
	overflow: visible !important;
}

::v-deep .el-table th.merge-header-left {
	border-right: none !important;
}

::v-deep .el-table th.merge-header-right {
	border-left: none !important;
}

::v-deep .el-table th.merge-header-right .cell {
	visibility: hidden;
	overflow: visible !important;
}

.view-switch {
	overflow: hidden;
	display: flex;
	cursor: pointer;
}

.switch-item-red {
	width: 80px;
	height: 32px;
	line-height: 32px;
	text-align: center;
	box-sizing: border-box;
	font-size: 14px;
	font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
	font-weight: 400;
	color: #E71D43;
	background: url('../../../assets/report/btn-red.png') no-repeat;
	background-size: 100% 100%;
	margin: 0px 8px;
}

.current-red {
	background: url('../../../assets/report/btn-red-checked.png') no-repeat !important;
	background-size: 100% 100% !important;
	color: #FFFFFF !important;
}
</style>